(function () {
  var SWIPER_SELECTOR =
    '.swiper,.js-slider-logos,.js-slider-logos-slow,.js-media-list,.js-media-sublist,.js-popup-slider,.js-recommendation-swiper';
  var bootEl = document.currentScript;
  var swiperSrc = bootEl && bootEl.dataset.swiperSrc;
  var swiperCss = bootEl && bootEl.dataset.swiperCss;

  function needsSwiper() {
    return Boolean(document.querySelector(SWIPER_SELECTOR));
  }

  function loadCss(href) {
    return new Promise(function (resolve, reject) {
      if (!href) {
        resolve();
        return;
      }
      var existing = document.querySelector('link[data-swiper-boot-css="' + href + '"]');
      if (existing) {
        resolve();
        return;
      }
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.dataset.swiperBootCss = href;
      link.addEventListener('load', function () {
        resolve();
      }, { once: true });
      link.addEventListener('error', reject, { once: true });
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-swiper-boot-src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', resolve, { once: true });
        existing.addEventListener('error', reject, { once: true });
        return;
      }

      var script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.dataset.swiperBootSrc = src;
      script.addEventListener(
        'load',
        function () {
          script.dataset.loaded = 'true';
          resolve();
        },
        { once: true }
      );
      script.addEventListener('error', reject, { once: true });
      document.head.appendChild(script);
    });
  }

  window.themeSwiperReady = new Promise(function (resolve, reject) {
    function loadWhenNeeded() {
      if (!needsSwiper()) {
        resolve(null);
        return;
      }

      if (!swiperSrc) {
        reject(new Error('Missing swiper src'));
        return;
      }

      // CSS early to avoid card/slider layout collapse; JS bundle stays IO-lazy.
      loadCss(swiperCss).catch(function () {});

      function doLoad() {
        loadScript(swiperSrc)
          .then(function () {
            resolve(window.Swiper || null);
          })
          .catch(reject);
      }

      var targets = document.querySelectorAll(SWIPER_SELECTOR);
      if (!('IntersectionObserver' in window) || !targets.length) {
        doLoad();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              observer.disconnect();
              doLoad();
              return;
            }
          }
        },
        { rootMargin: '200px 0px' }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadWhenNeeded, { once: true });
    } else {
      loadWhenNeeded();
    }
  });
})();
